import { useQueryClient, useQuery } from 'react-query';

export function useRefreshHardware() {
  const queryClient = useQueryClient();

  const refreshIndex = new Date().getTime();

  const refreshHardware = () => {
    queryClient.setQueryData(['refreshHardware'], refreshIndex);
  };

  const useRefreshHardwareQuery = (onRequestHardwareRefresh: () => void) => {
    useQuery(['refreshHardware'], () => {}, {
      onSuccess: () => {
        onRequestHardwareRefresh();
      },
      refetchOnWindowFocus: false,
    });
  };

  return { refreshHardware, useRefreshHardwareQuery };
}
